import { routeDefinitions, type RouteRecordRaw } from '@gat-ship/lib/router'

export function createSettingsRoutes(
  startPath: string
): readonly RouteRecordRaw[] {
  return [
    {
      path: startPath,
      component: () => import('../layouts/route-layout.vue'),
      children: [
        {
          path: 'agency/:nodeId',
          component: () => import('../layouts/agency-settings-layout.vue'),
          children: [
            {
              path: '',
              component: () => import('../views/view-agency-settings.vue'),
              name: routeDefinitions.administration.agencySettings,
              props: true
            }
          ]
        }
      ]
    }
  ]
}
